import React from 'react'
import { FormFieldType } from '@App/forms/v2/common/form-field'
import FormFieldFromProps from '@Fields/v2/FormFieldFromProps'
import SubmitButton from '@App/kit/fields/SubmitButton'
import Button from '@Components/Buttons/Button'

interface TopSectionProps {
    setNonEditable(): void
    disabled: boolean
    name: FormFieldType<string>
}

const TopSection = (props: TopSectionProps) => {
    const { disabled, name, setNonEditable } = props
    return (
        <>
            <div className="buttons-block">
                <Button onClick={setNonEditable} mainColor type="secondary">
                    Cancel
                </Button>
                <SubmitButton disabled={disabled} mainColor label="Save" />
            </div>
            <section className="name-section">
                <h5>Member Name </h5>
                <div className="fields-row-container">
                    <FormFieldFromProps field={name} isDisabled />
                </div>
            </section>
        </>
    )
}
export default TopSection
